import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ModalComponent } from '@app/shared/components';
import { PartNumber } from '@models/partNumber.model';
import { PartNumberEquivalent } from '@models/partNumberEquivalent.model';

@Component({
    selector: 'app-strain-update-main-part-number-modal',
    templateUrl: './strain-update-main-part-number-modal.component.html',
    styleUrls: ['./strain-update-main-part-number-modal.component.scss']
})
export class StrainUpdateMainPartNumberModalComponent {
    @ViewChild(ModalComponent, { static: false }) modal: ModalComponent;

    @Input() currentPartNumber: PartNumber;
    @Input() equivalentPartNumbers: PartNumberEquivalent[] = [];
    @Input() isUpdateInProgress = false;

    @Output() save = new EventEmitter<number>();

    selectedPartNumber = new FormControl(null, Validators.required);
    showValidations = false;

    open(event?: MouseEvent): void {
        event?.stopPropagation();
        this.showValidations = false;
        this.selectedPartNumber.setValue(null, { emitEvent: false });
        this.modal?.open();
    }

    close(): void {
        this.modal?.close();
    }

    onSave(): void {
        if (this.selectedPartNumber.invalid) {
            this.showValidations = true;
            this.selectedPartNumber.markAsTouched();
            return;
        }

        const value = this.selectedPartNumber.value;
        const partNumberId = value && typeof value === 'object' ? value.id : Number(value);
        if (!partNumberId) {
            return;
        }

        this.save.emit(partNumberId);
        this.close();
    }

    getDisplayName(): string {
        if (!this.currentPartNumber) {
            return 'N/A';
        }

        return `${this.currentPartNumber?.name} ( ${this.currentPartNumber?.sapGroup} - ${this.currentPartNumber?.sapFamily} )`;
    }
}
